export default "__VITE_ASSET__CqXZZj$L__"